module.exports = __webpack_public_path__ + "img/26.a30850c1.jpg";